import { aboutFeatures } from "@/mocks/comicGuide";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=flat%20manga%20style%20illustration%20of%20a%20young%20person%20cozily%20reading%20comic%20on%20smartphone%2C%20warm%20orange%20and%20cream%20tones%2C%20halftone%20dots%20and%20speed%20lines%20decorations%2C%20minimal%20clean%20composition%2C%20soft%20shadows%2C%20no%20text&width=800&height=800&seq=about-reader-2026&orientation=squarish"
              alt="66漫画网阅读体验，在手机上顺畅追更漫画"
              className="h-[340px] w-full object-cover object-top sm:h-[440px]"
            />
            <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1.5 text-xs text-foreground-800 backdrop-blur">
              <i className="ri-heart-3-fill text-primary-500"></i>
              用心做顺畅的阅读体验
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs text-primary-700">
              <i className="ri-store-2-line text-sm"></i>
              关于我们
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-900">
              让每一部漫画，都被读得畅快
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              66漫画网致力于把「阅读」这件事做简单。无论你是喜欢一口气往下刷的下拉党，
              还是偏爱一页一页翻的翻页派，亦或是想靠目录精准跳转、用全屏沉浸看细节的老读者，
              我们都希望你能在这里找到最顺手的打开方式。阅读设置里的一切选项，
              都是为了让你顺畅看完全篇、体验不卡壳。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              我们坚持轻快、清晰的阅读理念，持续优化下拉、翻页、目录与全屏四种模式，
              让追更这件事回归纯粹——翻开就能读，读起来就停不下。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {aboutFeatures.map((f) => (
                <div key={f.title} className="flex items-start gap-3 rounded-md bg-background-100 border border-background-200 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{f.title}</p>
                    <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}